import { useDispatch, useSelector } from "react-redux"
import { NavbarDescriptions } from "src/common/descriptions/components/navbar/types"
import { User } from "src/common/models/user"
import { RootState } from "src/state/reducer"
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    LogoutOutlined,
    UserOutlined,
    // FullscreenOutlined,
    // FullscreenExitOutlined,
} from '@ant-design/icons';
import * as Styles from './styles'
import { Link } from "react-router-dom"
import { Urls } from "src/common/urls"
import { toggleDrawerOpenStatus, toggleSidebarCollapse } from "../Sidebar/state/action"
import { SystemDescriptions } from "src/common/descriptions";
import { Company } from "src/common/models/company";

interface ReduxProps {
    user?: User
    isFullScreenMode: boolean
    isSidebarCollapsed: boolean
    isSidebarBroken: boolean
    isDrawerOpened: boolean
    company?: Company
}

export const Navbar = () => {

    const dispatch = useDispatch()

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        user: state.security.user,
        isFullScreenMode: state.menu.isFullScreenMode,
        isSidebarCollapsed: state.menu.sidebarCollapsed,
        isSidebarBroken: state.menu.sidebarBroken,
        isDrawerOpened: state.menu.drawerOpened,
        company: state.common.company,
    }))

    const descriptions: NavbarDescriptions = SystemDescriptions.COMPONENTS.NAVBAR

    const renderLeftSection = () => {

        const toggleSidebarCollapseStatusClick = () => {
            if (reduxProps.isSidebarBroken) {
                dispatch(toggleDrawerOpenStatus(!reduxProps.isDrawerOpened))
            } else {
                dispatch(toggleSidebarCollapse(!reduxProps.isSidebarCollapsed))
            }
        }

        return <Styles.SectionContainer>
            <Styles.NavbarItem
                type="text"
                icon={reduxProps.isSidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={toggleSidebarCollapseStatusClick}
            />
            <Styles.Title>
                {reduxProps.company?.name}
            </Styles.Title>
        </Styles.SectionContainer>
    }

    const renderRightSection = () => {

        // const toggleNavBarFullScreenStatus = () => {
        //     dispatch(toggleFullScreenMode(!reduxProps.isFullScreenMode))
        // }

        return <Styles.SectionContainer>
            {/* <Styles.NavbarItem
                type="text"
                icon={!reduxProps.isFullScreenMode ? <FullscreenOutlined rev={undefined} /> : <FullscreenExitOutlined rev={undefined} />}
                onClick={toggleNavBarFullScreenStatus}
            /> */}
            <Link
                to={Urls.FRONTEND.USER.EDIT_PAGE(reduxProps.user?.id ?? 0)}
            >
                <Styles.NavbarItem
                    type="text"
                    icon={<UserOutlined />}
                />
            </Link>

            <Link to={Urls.FRONTEND.LOGOUT}>
                <Styles.NavbarItem
                    type="text"
                    danger
                    icon={<LogoutOutlined />}
                    title={descriptions.LOGOUT.DISPLAY_NAME}
                >
                    {descriptions.LOGOUT.DISPLAY_NAME}
                </Styles.NavbarItem>
            </Link>
        </Styles.SectionContainer>
    }

    return (
        <Styles.HeaderApp >
            {renderLeftSection()}
            {renderRightSection()}
        </Styles.HeaderApp>

    )
}
